import React from 'react';
import useMetaTags from '../../hooks/useMetaTags';
import Benefits_section from '../../component/Services_Component/Benefits_section';
import Boost_section from '../../component/Services_Component/Boost_section';
import Assistance_section from '../../component/Services_Component/Assistance_section';
import FAQ_section from '../../component/Services_Component/FAQ_section';
import Role_writing from '../../component/Services_Component/Role_writing';
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";
import {
  LargeData,
  BenefitSection,
  roleWriting,
  FAQ,
  AssistanceSection,
  BoostSection,
} from "../../Data/All_Services_Data/seoData";

const SEO = () => {
    useMetaTags({
      title: "What Is Search Engine Optimization and Why Does It Matter?",
      description:
        "Search Engine Optimization is key to boosting visibility, ranking higher on Google, and attracting the right audience for long-term digital success.",
      keywords:
        "seo agency, seo, Search Engine optimization, SEO service, seo optimization companies, seo company, seo optimization agency, seo in marketing, Technical SEO, ecommerce seo services, seo consulting services, local seo services, seo expert, seo agency ecommerce, SEO Serivces",
    });
    return (
      <>
        <section
          className=""
          style={{
            backgroundImage: `url('assets/img/service/serviceD.jpg')`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
          id="service-sec"
        >
          <div className="round-container pt-5">
            <div className="container">
              <div className="title-area text-center">
                <span className="sub-title text-white">OUR SERVICES</span>
                <h1 className="sec-title text-white">
                  Search Engine Optimization (SEO) Agency
                </h1>
              </div>
            </div>
          </div>
        </section>
        <section className="space-extra-bottom">
          <div className="page-single">
            <div className="page-content">
              <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
              {/* Intro part  */}
              <div
                className="header-section container"
                style={{ marginTop: "20px" }}
              >
                <img
                  src="assets/img/icon/seo.png"
                  loading="lazy"
                  alt="heading_image"
                />
                <div>
                  <p>
                    We are an outcomes focused SEO firm which we put to work for
                    you to increase your online presence, drive in organic
                    traffic, and we’ll maximize your digital growth. It is our
                    mission to see your brand at the top of search engines. With
                    our back approaches and data driven execution we transform
                    your website into a lead machine.
                  </p>
                </div>
              </div>
              {/* A Complete SEO Agency for Your Success  */}
              <Handle_Largedata_section LargeData={LargeData} />

              {/* The Power of Organic Search Engine Optimization Services  */}
              <Benefits_section data={BenefitSection} />

              {/* A Smarter Approach to Organic Search Optimization */}
              <Role_writing data={roleWriting} />

              {/* How Warrgyizmorsch Can Help Grow Your Business?  */}
              <Boost_section data={BoostSection} />

              {/* How SEO Marketing Services Can Elevate Your Business Growth?  */}
              <Assistance_section data={AssistanceSection} />

              {/* FAQ section  */}
              <FAQ_section data={FAQ} />
            </div>
          </div>
        </section>
        <div className="scroll-top">
          <svg
            className="progress-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
          >
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              style={{
                transition: "stroke-dashoffset 10ms linear 0s",
                strokeDasharray: "307.919, 307.919",
                strokeDashoffset: "307.919",
              }}
            ></path>
          </svg>
        </div>
      </>
    );
};

export default SEO;